import { render, staticRenderFns } from "./publications.vue?vue&type=template&id=48182890"
import script from "./publications.vue?vue&type=script&lang=js"
export * from "./publications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports